import { NgModule } from '@angular/core';
import { CoreModule } from '../core/core.module';
import { LoginPage } from './all/login/login.page';
import { GeenToegangPage } from './all/geentoegang/geen-toegang.page.component';
import { RouterModule } from '@angular/router';
import { RegioverantwoordelijkenPage } from './admin/regioverantwoordelijken/regioverantwoordelijken.page';
import { AddRegioverantwoordelijkePage } from './admin/add-regioverantwoordelijke/add-regioverantwoordelijke.page';
import { RegioverantwoordelijkeModule } from '../regioverantwoordelijke/regioverantwoordelijke.module';
import { TherapeutenPage } from './admin/therapeuten/therapeuten.page';
import { TherapeutModule } from '../therapeut/therapeut.module';
import { ThuisverzorgersPage } from './admin/thuisverzorgers/thuisverzorgers.page';
import { ThuisverzorgerModule } from '../thuisverzorger/thuisverzorger.module';
import { AddTherapeutPage } from './admin/add-therapeut/add-therapeut.page';
import { AddThuisverzorgerPage } from './admin/add-thuisverzorger/add-thuisverzorger.page';
import { AdminModule } from '../admin/admin.module';
import { AdminsPage } from './admin/admins/admins.page';
import { AddAdminPage } from './admin/add-admin/add-admin-page.component';
import { AddClientPage } from './regioverantwoordelijke/add-client/add-client.page';
import { ClientenPage } from './regioverantwoordelijke/clienten/clienten.page';
import { ClientModule } from '../client/client.module';
import { ZoneModule } from '../zone/zone.module';
import { DienstModule } from '../dienst/dienst.module';
import { StartPrestatiePage } from './thuisverzorger/start-prestatie/start-prestatie.page';
import { EditClientPage } from './regioverantwoordelijke/edit-client/edit-client-page.component';
import { ClientDienstenBeheerPage } from './regioverantwoordelijke/client-diensten-beheer/client-diensten-beheer.page';
import { CommonModule } from '@angular/common';
import { AdminPage } from './admin/admin/admin.page';
import { RegioverantwoordelijkePage } from './admin/regioverantwoordelijke/regioverantwoordelijke.page';
import { TherapeutPage } from './admin/therapeut/therapeut.page';
import { ThuisverzorgerPage } from './admin/thuisverzorger/thuisverzorger.page';
import { PrestatieModule } from '../prestatie/prestatie.module';
import { PrestatieDienstenPage } from './thuisverzorger/prestatie-diensten/prestatie-diensten.page';
import { PrestatieTakenPage } from './thuisverzorger/prestatie-taken/prestatie-taken.page';
import { StopPrestatiePage } from './thuisverzorger/stop-prestatie/stop-prestatie.page';
import { PrestatiePage } from './regioverantwoordelijke/prestatie/prestatie.page';
import { PrestatiesPage } from './regioverantwoordelijke/prestaties/prestaties.page';
import { ExportsPage } from './regioverantwoordelijke/exports/exports-page.component';
import { ExportsModule } from '../exports/exports.module';
import { SignaalkaartModule } from '../signaalkaart/signaalkaart.module';
import { SignaalkaartenPage } from './thuisverzorger/signaalkaarten/signaalkaarten.page';
import { SignaalkaartPage } from './thuisverzorger/signaalkaart/signaalkaart.page';
import { MeldingenPage } from './all/meldingen/meldingen.page';
import { ClientMeldingModule } from '../client-melding/client-melding.module';
import { ZoekClientPage } from './therapeut/zoek-client/zoek-client.page';
import { ClientDienstenPage } from './all/client-diensten/client-diensten.page';
import { AlgemeneMeldingModule } from '../algemene-melding/algemene-melding.module';
import { ActiviteitenPage } from './regioverantwoordelijke/activiteiten/activiteiten.page';
import { ActiviteitModule } from '../activiteit/activiteit.module';
import { TipsPage } from './all/tips/tips.page';
import { ClientTipModule } from '../client-tip/client-tip.module';
import { AlgemeneTipModule } from '../algemene-tip/algemene-tip.module';
import { SignaalkaartAntwoordenPage } from './all/signaalkaart-antwoorden/signaalkaart-antwoorden.page';
import { SignaalkaartAntwoordPage } from './all/signaalkaart-antwoord/signaalkaart-antwoord.page';
import {ClientFicheBeheerPage} from './regioverantwoordelijke/client-fiche-beheer/client-fiche-beheer.page';
import {ClientFichePage} from './all/client-fiche/client-fiche.page';

const pages = [
  LoginPage,
  GeenToegangPage,
  AdminPage,
  AdminsPage,
  AddAdminPage,
  RegioverantwoordelijkePage,
  RegioverantwoordelijkenPage,
  AddRegioverantwoordelijkePage,
  TherapeutPage,
  TherapeutenPage,
  AddTherapeutPage,
  ThuisverzorgerPage,
  ThuisverzorgersPage,
  AddThuisverzorgerPage,
  AddClientPage,
  EditClientPage,
  ClientenPage,
  ClientDienstenBeheerPage,
  ClientFicheBeheerPage,
  ClientFichePage,
  StartPrestatiePage,
  PrestatieDienstenPage,
  PrestatieTakenPage,
  StopPrestatiePage,
  PrestatiesPage,
  PrestatiePage,
  ExportsPage,
  SignaalkaartenPage,
  SignaalkaartPage,
  MeldingenPage,
  ZoekClientPage,
  ClientDienstenPage,
  ActiviteitenPage,
  TipsPage,
  SignaalkaartAntwoordenPage,
  SignaalkaartAntwoordPage,
];

@NgModule({
  declarations: [...pages],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule,
    AdminModule,
    RegioverantwoordelijkeModule,
    TherapeutModule,
    ThuisverzorgerModule,
    ClientModule,
    ZoneModule,
    DienstModule,
    PrestatieModule,
    ExportsModule,
    SignaalkaartModule,
    ClientMeldingModule,
    AlgemeneMeldingModule,
    ActiviteitModule,
    ClientTipModule,
    AlgemeneTipModule,
  ],
  exports: [...pages],
})
export class PageModule {}
